import { supabase } from "../../lib/supabaseClient";

const TTL = 5 * 60 * 1000;
let _cache = new Map(); // email -> { at, ok }

export async function isEmailAllowed(email) {
  const e = String(email || "").trim().toLowerCase();
  if (!e) return false;
  if (e.endsWith("@flipspaces.com")) return true; // always allowed internal

  const hit = _cache.get(e);
  if (hit && Date.now() - hit.at < TTL) return hit.ok;

  const { data, error } = await supabase.rpc("is_email_allowed", { check_email: e });
  if (error) return false; // fail closed
  const ok = data === true;
  _cache.set(e, { at: Date.now(), ok });
  return ok;
}

export function resetAllowlistCache() {
  _cache = new Map();
}
